import React from 'react';
import { GridIcon, WaterIcon, BlueprintIcon, PipelineIcon } from '../components/IndustryIcons';
import { FocalQuote, Panel, SectionFrame } from '../components/SectionFrame';
const milestones = [{
  Icon: BlueprintIcon,
  period: '2006 — 2015',
  title: '$187M Reclaimed Water Reuse Project',
  body: 'Conceived and delivered the reclaimed water reuse initiative serving Polk Power Station and local municipalities, securing $64M+ in external co-funding and earning the 2015 Edison Award for innovation, sustainability, and infrastructure excellence.',
  stat: '$64M+ co-funded'
}, {
  Icon: PipelineIcon,
  period: '2015 — 2017',
  title: 'The AMI Business Case',
  body: 'Built and secured executive and corporate approval for the Advanced Metering Pilot business case — the decision that launched the utility\'s transition to advanced metering — while directing engineering, testing, and procurement for $77M in revenue metering assets.',
  stat: '$77M metering assets'
}, {
  Icon: GridIcon,
  period: '2017 — 2022',
  title: '$250M AMI Deployment & $153M LED Conversion',
  body: 'Led the PMO for the Advanced Metering Infrastructure deployment — delivered ahead of schedule and under budget — with enterprise integration across CRB, OMS, and ADMS platforms, alongside the LED lighting conversion program and $120M in regulated outdoor lighting systems.',
  stat: '~400 direct & contracted staff'
}, {
  Icon: WaterIcon,
  period: '2022 — Present',
  title: '$3.3B Grid Modernization Roadmap',
  body: 'Authored the multi-year grid modernization roadmap centered on resilience and AI readiness, delivered the enterprise data analytics platform and first enterprise data governance model, and executed the Advanced Distribution Intelligence program.',
  stat: 'Resilience + AI readiness'
}];
export function Infrastructure() {
  return <SectionFrame index="04" eyebrow="Executed Capital Programs" headline="Mega-Project Delivery & Grid Modernization Infrastructure" subheadline="Two decades of capital programs carried from business case through regulatory approval to commissioned asset — metering, lighting, water reuse, and the grid roadmap that follows them." data-id="element-245" data-mp="32r0nvizmftqe">
      <ol className="relative grid gap-6 lg:grid-cols-2" data-id="element-246" data-mp="2o2h4m65u3uhi">
        {milestones.map(({
        Icon,
        period,
        title,
        body,
        stat
      }) => <li key={title} data-id="element-247" data-mp="3btwbmc8k2zz3">
            <Panel className="flex h-full flex-col p-7" data-id="element-248" data-mp="3btd1hhp5dfvm">
              <div className="flex items-start justify-between gap-4" data-id="element-249" data-mp="3grxx13tgfbdq">
                <Icon className="h-9 w-9 text-hydro" data-id="element-250" data-mp="3231o74jkpuc2" />
                <span className="tabular text-[11px] font-semibold uppercase tracking-[0.2em] text-copper" data-id="element-251" data-mp="3228ognj1853f">
                  {period}
                </span>
              </div>
              <h2 className="display mt-5 text-2xl font-black leading-tight text-steel-dark" data-id="element-252" data-mp="3uqearepqi25d">{title}</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-steel-dark/85" data-id="element-253" data-mp="3djohcu0ymjb">{body}</p>
              <p className="mt-auto border-t border-panel-deep pt-4 text-[13px] font-semibold uppercase tracking-[0.14em] text-hydro" data-id="element-254" data-mp="1o25a52nf0rwm">
                {stat}
              </p>
            </Panel>
          </li>)}
      </ol>

      <Panel tone="steel" className="mt-6 p-7 sm:p-9" data-id="element-255" data-mp="1xs6x1r41849y">
        <h2 className="display text-2xl font-black text-panel" data-id="element-256" data-mp="1stnapplj0qh2">Regulatory Path Cleared, Not Waited On</h2>
        <p className="mt-3 max-w-4xl text-[15px] leading-relaxed text-panel/75" data-id="element-257" data-mp="153jaztbglavc">
          Secured Transmission Line Siting Act and Power Plant Siting Act approvals through Siting Board reviews,
          Governor and Cabinet certifications, and contested public hearings; negotiated EPA Consent Decree
          modifications and closed Consent Orders with the EPA, FDEP, and DOJ across gas, coal, and oil-fired
          generation; oversaw negotiation and clean-up of seven Manufactured Gas Plant sites carrying $45M+ in
          liability.
        </p>
        <p className="mt-5 max-w-4xl border-t border-white/10 pt-5 text-[15px] leading-relaxed text-panel/75" data-id="element-258" data-mp="2lkx69skjw9gj">
          Secured the final Class V injection permit issued under the Obama Administration through direct negotiation
          with EPA Administrator Lisa Jackson and members of Congress — the approval that made the reclaimed water
          reuse program executable.
        </p>
      </Panel>

      <FocalQuote data-id="element-259" data-mp="3m7hfjigk0px">
        Infrastructure built with foresight creates multi-generational reliability and sustainable community value.
      </FocalQuote>
    </SectionFrame>;
}